import graphql from 'babel-plugin-relay/macro';

export const REMOVE_ACCOUNT_MUTATION = graphql`
  mutation SettingsMutationsDeleteAccountMutation($pid: ID!) {
    deleteProfile(pid: $pid) {
      id
    }
  }
`;
